@import '../../styles/variables.scss';

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.25rem;
  font-weight: 500;
  color: var(--bs-body-color);
  background-color: transparent;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;

  &:focus {
    outline: none;
  }

  &:disabled {
    opacity: 0.6;
  }
}

.primary {
  color: var(--button-color);
  background-color: var(--button-bg);

  &:hover {
    background-color: var(--button-hover-bg);
  }

  &:disabled {
    background-color: var(--button-bg);
  }
}

.secondary {
  color: var(--button-secondary-color);
  border-color: $secondary;

  &:hover {
    border-color: darken($secondary, 15%);
  }

  &:disabled {
    border-color: $secondary;
  }
}

.tertiary {
  &:hover {
    color: $primary;
  }

  &:disabled {
    color: $body-color;
  }
}
